import React from 'react';
import Layout from '../Layout';
import { useSelector } from 'react-redux';
import { AgencyAppState } from 'src/redux/modules/store';
import CustomerListSearchScreen from '@common/component/templates/CustomerListSearchScreen';
import StoreSelectModal from '../../../container/organisms/StoreSelectModalContainer';

/**
 * コンポーネント名
 */
export const componentName = 'CustomerInfoListAgency';

/**
 * 顧客一覧のUIコンポーネント(画面表示要件のUIコンポーネントのラッパーコンポーネント)
 */
const CustomerInfoList: React.FC = () => {
  /**
   * global states
   */
  const { isLoggedIn, crewCd, searchCustomerListConditionState, storeSelectorState } = useSelector((state: AgencyAppState) => ({
    isLoggedIn: state.loginUser.isLoggedIn,
    crewCd: state.loginUser.crewCd,
    searchCustomerListConditionState: state.searchCustomerListCondition,
    storeSelectorState: state.storeSelector,
  }));

  const targetStoreList = storeSelectorState.selectedStores;

  return (
    <Layout isLoggedIn={isLoggedIn}>
      <CustomerListSearchScreen
        userId={crewCd}
        isCrewModule={false}
        searchCondition={searchCustomerListConditionState}
        targetStoreList={targetStoreList}
      />

      <StoreSelectModal />
    </Layout>
  );
};

export default CustomerInfoList;
